<template>
  <div class="remote_sims">

    <TextTable
      :all_data = "all_data"
    />

  </div>
</template>

<script>

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'RemoteSims',
  components: {
    TextTable
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      load: true,
      all_data: {}
    }
  },

  created () {
    this.get_remote_sims()
  },

  methods: {
    get_remote_sims(){
      this.$http.simcard.getRemoteSims((response) => {
        this.all_data = response.data
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .remote_sims{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
